import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// NOTIFY KAYLA IF YOU MAKE ANY CHANGES TO THIS FILE

function InputGroupCheckButton(props) {
  const disabledClass = props.disabled ? 'disabled ' : ''
  const additionalClassName = props.className || ''
  return (
    <div
        id={props.id || null}
        data-title={props['data-title']}
        data-toggle={props['data-toggle']}
        data-placement={props['data-placement'] || 'top'}
        className={'btn btn-default ' + disabledClass + additionalClassName}
        aria-label={props.ariaLabel}
        style={props.style}
        onClick={() => {
          if (!props.disabled) {
            props.onChange()
          }
        }}
      >
        <FontAwesomeIcon
          icon={['far', props.checked ? 'check-square' : 'square']}
        />
        &nbsp; {props.text}
      </div>
    )
}

InputGroupCheckButton.defaultProps = {
  onChange: () => {},
  ariaLabel: 'no label',
  text: '',
  disabled: false,
  checked: false,
  style: {}
}

InputGroupCheckButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  style: PropTypes.object,
  onChange: PropTypes.func,
  'data-title': PropTypes.string,
  'data-toggle': PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  'data-placement': PropTypes.string

}

export default InputGroupCheckButton
